import { render } from "./InformationView.vue?vue&type=template&id=d8d20b04&scoped=true"
import script from "./InformationView.vue?vue&type=script&lang=js"
export * from "./InformationView.vue?vue&type=script&lang=js"

import "./InformationView.vue?vue&type=style&index=0&id=d8d20b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d20b04"]])

export default __exports__